import React, { Component } from 'react';
// import PropTypes from 'prop-types';

// Components
// import { Container } from 'reactstrap'
import FullPageLayout from '../../components/FullPageLayout'
// import Box from './components/Box'
import AbsPosButton from './components/AbsPosButton'


// ----------------------------------------------------------------------------




// ----------------------------------------------------------------------------

class DemoPage extends Component {

  state = {
    boxes: [0]
  }

  handleToggleLoading() {
    this.props.setLoading(true);
  }

  // handleAddSquare() {
  //   var newBoxes = this.state.boxes.slice();
  //   newBoxes.push(1);
  //
  //   this.setState({ boxes: newBoxes });
  // }
  //
  // handleRemoveSquare() {
  //   const { boxes } = this.state;
  //   var newBoxes = [];
  //
  //   for (let i=0; i < boxes.length-1; i++)
  //     newBoxes.push(i);
  //
  //   this.setState({ boxes: newBoxes });
  // }

  render() {
    return (
      <div>
        <FullPageLayout>
          <div style={{padding: '2rem'}}>

            <AbsPosButton
              top="20%"
              onClick={() => this.handleToggleLoading()}
            >
              Toggle Loading
            </AbsPosButton>



          </div>
        </FullPageLayout>
      </div>
    );
  }
}

export default DemoPage;



// WEBPACK FOOTER //
// ./src/pages/Demo/Demo.js